import { useMutation } from '@tanstack/react-query';
import { addHardwareProductVersion } from '../../../actionCreators/hardwareproduct';

export function useAddHardwareVersion() {
  return useMutation({
    mutationKey: ['add-hardware-version'],
    mutationFn: (version: any) => addHardwareProductVersion(version),
  });
}
